import React, { createContext, useContext } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useChat } from '../hooks/useChat';

const ChatContext = createContext(null);

export function ChatProvider({ children }) {
  const { getAccessTokenSilently } = useAuth0();

  const getToken = () => getAccessTokenSilently({
    authorizationParams: { audience: process.env.REACT_APP_AUTH0_AUDIENCE },
  });

  const chat = useChat(getToken);

  return (
    <ChatContext.Provider value={chat}>
      {children}
    </ChatContext.Provider>
  );
}

export function useChatContext() {
  const ctx = useContext(ChatContext);
  if (!ctx) throw new Error('useChatContext must be used within a ChatProvider');
  return ctx;
}